import { Moment } from 'moment';
import {
  FlightPassenger,
} from '../../store/flightSearch/types';
import {
  BusTravelRoute,
  RoadSearchPayload,
  RoadSearchStore,
} from '../../store/roadSearch/types';
import moment from 'moment';

type RoadDateValue = Moment | Date | string | { from?: Date; to?: Date };

type PaxCounter = {
  numberOfAdults: number;
  numberOfChildren?: number;
  numberOfInfants?: number;
}

type TravelRouteArg = {
  DepartureDate?: RoadDateValue,
  ArrivalDate?: RoadDateValue,
  ArrivalId?: number,
  DepartureId?: number
}
const generateFlightPassengersCount = ({
  numberOfAdults,
  numberOfChildren,
  numberOfInfants,
}: PaxCounter): FlightPassenger[] => {
  const payload = [
    {
      Code: 'ADT',
      Quantity: numberOfAdults,
    },
  ];

  if (numberOfChildren) {
    payload.push({
      Code: 'CHD',
      Quantity: numberOfChildren,
    });
  }

  if (numberOfInfants) {
    payload.push({
      Code: 'INF',
      Quantity: numberOfInfants,
    });
  }

  return payload;
};

export const formatRoadDate = (date: any): string => {
  if (!date) return "";

  if (date.from && typeof date.from !== "function") {
    return moment(date.from).format("YYYY-MM-DD");
  }

  if (typeof date.format === "function") {
    return date.format("YYYY-MM-DD");
  }

  return moment(date).format("YYYY-MM-DD");
};

export const formatRoadReturnDate = (departureDate: any, arrivalDate: any): string | undefined => {
  if (departureDate?.to && typeof departureDate.to !== "function") {
    return moment(departureDate.to).format("YYYY-MM-DD");
  }

  if (arrivalDate) {
    return formatRoadDate(arrivalDate);
  }

  return undefined;
};

const generateTravelRoutes = (arg: TravelRouteArg): BusTravelRoute => {
  // const DepartureDate = arg.DepartureDate ? arg.DepartureDate.format('YYYY-MM-DD') : '';
  // const ArrivalDate = arg.ArrivalDate ? arg.ArrivalDate.format('YYYY-MM-DD') : undefined;
  const DepartureDate = formatRoadDate(arg.DepartureDate);
  const ArrivalDate = formatRoadReturnDate(arg.DepartureDate, arg.ArrivalDate);

  return {
    DepartureId: arg.DepartureId,
    ArrivalId: arg.ArrivalId,
    DepartureDate,
    ArrivalDate,
  };
};

export const buildSearchPayload = (data: RoadSearchStore): RoadSearchPayload => {
  const {
    Currency,
    From,
    PageSize,
    OrderbyDepartureTime,
    OrderByPrice,
    DepartureDate,
    ArrivalDate,
    DepartureId,
    ArrivalId,
    TripType,
  } = data;

  const IsRoundTrip = TripType === 'round_trip';

  const payload = {
    Parameter: {
      TravelRoute: generateTravelRoutes({
        DepartureDate,
        DepartureId: parseInt(DepartureId, 10),
        ArrivalId: ArrivalId ? parseInt(ArrivalId, 10) : undefined,
        ArrivalDate: IsRoundTrip ? ArrivalDate : undefined,
      }),
      PassengerTypes: generateFlightPassengersCount({ numberOfAdults: 1 }),
      IsRoundTrip,
      // USE Currecny from the config
      Currency: Currency || 'KES',
      OrderbyDepartureTime,
      OrderByPrice,
    },
    PageSize,
    From,
  };

  return payload;
};
